export default __webpack_public_path__ + "static/media/img3.331526e7.jpeg";